import { render, staticRenderFns } from "./InspectionHighlights.vue?vue&type=template&id=6e2b3097&scoped=true"
import script from "./InspectionHighlights.vue?vue&type=script&lang=js"
export * from "./InspectionHighlights.vue?vue&type=script&lang=js"
import style0 from "./InspectionHighlights.vue?vue&type=style&index=0&id=6e2b3097&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b3097",
  null
  
)

export default component.exports